import React, { useState, useMemo } from "react";
import { useDispatch } from "react-redux";
import AttendanceDataTable from "components/TableContainers/AttendanceDataTable";
import { fetchAttendanceRequest } from "store/attendance/actions";

const AttendanceTable = ({ data, loading, totalrows,courseOptions }) => {
  const dispatch = useDispatch();

  // Local table states
  const [selectedSortData, setSelectedSortData] = useState({
    value: "studentName",
    direction: "asc",
  });
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchString, setSearchString] = useState("");
  const [selectedCourse, setSelectedCourse] = useState(null);

  // Columns
  const columns = useMemo(
    () => [
      { header: "Student Name", accessorKey: "studentName" },
      { header: "Email", accessorKey: "studentEmail" },
      { header: "Total Days", accessorKey: "totalDays" },
      { header: "Present Days", accessorKey: "presentDays" },
      {
        header: "Attendance %",
        accessorKey: "attendancePercentage",
        cell: ({ row }) => (
          <span>{row.original.attendancePercentage.toFixed(2)}%</span>
        ),
      },
    ],
    []
  );

  // Fetch new data when filters change
  React.useEffect(() => {
    const params = {
      page: pageIndex,
      limit: pageSize,
      search: searchString || "",
      sortBy: selectedSortData
        ? `${selectedSortData.value}:${selectedSortData.direction}`
        : "studentName:asc",
      ...(selectedCourse ? { courseId: selectedCourse.value } : {}),
    };
    dispatch(fetchAttendanceRequest(params));
  }, [dispatch, pageIndex, pageSize, searchString, selectedSortData, selectedCourse]);

  return (
    <div className="container-fluid">
      <AttendanceDataTable
        columns={columns}
        data={data}
        loading={loading}
        totalrows={totalrows}
        courseOptions={courseOptions}
        selectedSortData={selectedSortData}
        setSelectedSortData={setSelectedSortData}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        pageSize={pageSize}
        setPageSize={setPageSize}
        searchString={searchString}
        setSearchString={setSearchString}
        selectedCourse={selectedCourse}
        setSelectedCourse={setSelectedCourse}
      />
    </div>
  );
};

export default AttendanceTable;
